type ProductionUnitOption = {
  id?: string | null
}

const normalizeId = (value?: string | null): string => (
  typeof value === 'string' ? value.trim() : ''
)

const getAvailableUnitIds = (units: ProductionUnitOption[]): Set<string> => (
  new Set(units.map((unit) => normalizeId(unit.id)).filter((unitId) => unitId.length > 0))
)

export const resolveHydratedProductionUnitId = (params: {
  activeProductionUnitId?: string
  currentProductionUnitId?: string
  units: ProductionUnitOption[]
}): string => {
  const availableUnitIds = getAvailableUnitIds(params.units)
  const activeProductionUnitId = normalizeId(params.activeProductionUnitId)
  if (activeProductionUnitId && availableUnitIds.has(activeProductionUnitId)) {
    return activeProductionUnitId
  }

  const currentProductionUnitId = normalizeId(params.currentProductionUnitId)
  if (currentProductionUnitId && availableUnitIds.has(currentProductionUnitId)) {
    return currentProductionUnitId
  }

  return ''
}

export const normalizeSelectedProductionUnitId = (params: {
  selectedProductionUnitId?: string
  units: ProductionUnitOption[]
}): string => {
  const selectedProductionUnitId = normalizeId(params.selectedProductionUnitId)
  if (!selectedProductionUnitId) {
    return ''
  }

  const availableUnitIds = getAvailableUnitIds(params.units)
  if (!availableUnitIds.has(selectedProductionUnitId)) {
    return ''
  }

  return selectedProductionUnitId
}